import { Routes } from '@angular/router';
import { ConfiguracoesComissoes } from '@/features/configuracoes/comissoes/configuracoes-comissoes';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';

const rootPath = CONFIGURACOES_ROUTES.COMISSOES.ROOT;

export const configuracoesComissoesRoutes: Routes = [
    {
        path: rootPath,
        data: { breadcrumb: 'Comissões' },
        children: [{ path: '', component: ConfiguracoesComissoes }]
    }
];

export default configuracoesComissoesRoutes;
